export default __webpack_public_path__ + "static/media/Poppins-Bold.266c2af2.woff";